const COGNITO_PREFIX = 'CognitoIdentityServiceProvider.'
const LAST_AUTH_USER = '.LastAuthUser'

const findStoredIdToken = (storage: Storage): string | undefined => {
  for (let index = 0; index < storage.length; index += 1) {
    const key = storage.key(index)

    if (!key?.startsWith(COGNITO_PREFIX) || !key.endsWith(LAST_AUTH_USER)) {
      continue
    }

    const user = storage.getItem(key)

    if (!user) continue

    const token = storage.getItem(
      `${key.slice(0, -LAST_AUTH_USER.length)}.${user}.idToken`
    )

    if (token) return token
  }

  return undefined
}

// Amplify keeps the Cognito session in localStorage. Storage access throws
// where the browser blocks it (sandboxed iframes, blocked site data).
export const hasStoredSession = (storage?: Storage): boolean => {
  try {
    return findStoredIdToken(storage ?? localStorage) !== undefined
  } catch {
    return false
  }
}
